import React from "react";
import Typography from "@/ui/Typography/Typography";
import { CheckIcon } from "@/assets/icons";
import { FlexColumn, FlexRow } from "@/ui/FlexContainer/FlexContainer";
import { useUserDataContext } from "@/store/UserProvider";
import { useTranslation } from "react-i18next";
import cls from "./styles.module.scss";

export default function PremiumDescription({
  onSubscriptionCancel,
}: {
  onSubscriptionCancel?: () => void;
}) {
  const { t } = useTranslation();
  const { user } = useUserDataContext();

  if (!user) return;

  return (
    <div className={cls.tariff}>
      <FlexRow justifyContent="space-between" alignItems="flex-start">
        <FlexColumn gap={0}>
          <Typography variant="body1" className={cls.bold}>
            {t("premiumDescription.yourTariff")}
          </Typography>
          <Typography variant="body1" className={cls.qwe}>
            {t("common.pricePerMonth", {
              price: user?.subscription_price,
            })}
          </Typography>
        </FlexColumn>

        <Typography variant="body1" className={cls.small}>
          {t("premiumDescription.nextPayment")}
          <br />
          {new Date(user.subscription_ends_at).toLocaleDateString("ru-Ru")}
        </Typography>
      </FlexRow>
      <div className={cls.features}>
        <div className={cls.feature}>
          <CheckIcon />
          <Typography variant="body1" className={cls.qwe}>
            {t("premiumDescription.currentDeliveryRates")}
          </Typography>
        </div>
        <div className={cls.feature}>
          <CheckIcon />
          <Typography variant="body1" className={cls.qwe}>
            {t("premiumDescription.currentTaxiRates")}
          </Typography>
        </div>
        <div className={cls.feature}>
          <CheckIcon />
          <Typography variant="body1" className={cls.qwe}>
            {t("premiumDescription.routePlanning")}
          </Typography>
        </div>
      </div>
      {onSubscriptionCancel && (
        <button
          className={cls.cancelButton}
          type="button"
          onClick={onSubscriptionCancel}
        >
          {t("common.cancelSubscription")}
        </button>
      )}
    </div>
  );
}
